import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getHomePageUrl } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { generateLinksFrom } from "@insite/content-library/Components/PageBreadcrumbs";
import { injectMetadata, removeMetadata } from "@waytek/Utilities/global/injectMetadata";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    location: string[];
    id: string;
}

const mapStateToProps = (state: ApplicationState) => {
    const currentPage = getCurrentPage(state);

    return {
        links: state.components.breadcrumbs.links,
        linksState: state.links,
        nodeId: currentPage.nodeId,
        homePageUrl: getHomePageUrl(state),
        currentPage,
    };
};

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const SchemaForBreadcrumbs: React.FC<Props> = ({
    location,
    id,
    links,
    linksState,
    nodeId,
    homePageUrl,
    currentPage,
}) => {
    const currentPageType = currentPage.type;

    if (!location.includes(currentPageType)) {
        removeMetadata(id);
        return null;
    }

    let breadcrumbs = links || generateLinksFrom(linksState, nodeId, homePageUrl);
    if (breadcrumbs.length > 0) {
        const homePageLink = { children: translate("Home_Breadcrumb"), href: homePageUrl };
        const linksWithoutHomePageLink = [...breadcrumbs].splice(1, breadcrumbs.length);
        breadcrumbs = [homePageLink, ...linksWithoutHomePageLink];
    }

    const elements: any[] = [];

    breadcrumbs.forEach((item, index) => {
        elements.push({
            "@type": "ListItem",
            position: index + 1,
            item: {
                "@id": item.href,
                name: item.children,
            },
        });
    });

    if (elements.length < 1) {
        return null;
    }

    const schemaData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: elements,
    };

    injectMetadata(JSON.stringify(schemaData), id);

    return null;
};

export default connect(mapStateToProps, mapDispatchToProps)(SchemaForBreadcrumbs);
